import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const WifiTetheringErrorIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"wifi_tethering_error"} ref={ref}/>
});

WifiTetheringErrorIcon.displayName = "WifiTetheringErrorIcon";
